import { useState, useEffect, useCallback } from 'react';
import axios, { API, authHeaders, errText } from '../api';
import Layout from './Layout';
import { ui } from '../ui';
import { colors } from '../theme';
import { getRole } from '../auth';
import PhotoLightbox from '../components/PhotoLightbox';

export default function PhotoRequests() {
  const role = getRole();
  const base = role === 'super_admin' ? '/admin' : '/curator';

  const [items, setItems] = useState(null);
  const [rejectingId, setRejectingId] = useState(null);
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const [lightboxUrl, setLightboxUrl] = useState(null);

  const fetchItems = useCallback(() => {
    axios.get(`${API}${base}/photo-requests`, { headers: authHeaders() }).then(r => setItems(r.data));
  }, [base]);
  useEffect(() => { fetchItems(); }, [fetchItems]);

  const approve = async (req) => {
    if (!window.confirm(`Одобрить замену главного фото для ${req.user_name || req.user_phone}?`)) return;
    setError('');
    try {
      await axios.post(`${API}${base}/photo-requests/${req.id}/approve`, {}, { headers: authHeaders() });
      fetchItems();
    } catch (e) {
      setError(errText(e, 'Не удалось одобрить заявку'));
    }
  };

  const startReject = (req) => { setRejectingId(req.id); setReason(''); };
  const cancelReject = () => setRejectingId(null);

  const confirmReject = async (req) => {
    if (!reason.trim()) return;
    setError('');
    try {
      await axios.post(`${API}${base}/photo-requests/${req.id}/reject`, { reason: reason.trim() }, { headers: authHeaders() });
      setRejectingId(null);
      fetchItems();
    } catch (e) {
      setError(errText(e, 'Не удалось отклонить заявку'));
    }
  };

  return (
    <Layout>
      <h1 style={ui.title}>Запросы на замену фото</h1>
      <p style={{ color: colors.textMuted, fontSize: 13, marginTop: -10, marginBottom: 20 }}>
        Пользователь просит заменить своё главное (заблокированное) фото на новое. Сравните старое
        и новое фото и одобрите или отклоните — при отклонении причина обязательна, пользователь
        увидит её в сообщениях в приложении.
      </p>

      {error && <div style={{ ...ui.error, marginBottom: 16 }}>{error}</div>}

      {items === null ? (
        <div style={ui.empty}>Загрузка…</div>
      ) : items.length === 0 ? (
        <div style={ui.card}><div style={ui.empty}>Заявок на рассмотрении нет</div></div>
      ) : (
        items.map((req) => (
          <div key={req.id} style={ui.card}>
            <div style={{ fontWeight: 600, marginBottom: 12 }}>
              {req.user_name || 'Без имени'}, {req.user_phone}
            </div>
            <div style={{ display: 'flex', gap: 24, marginBottom: 16 }}>
              <div>
                <div style={{ fontSize: 12, color: colors.textMuted, marginBottom: 6 }}>Было</div>
                {req.old_photo_url ? (
                  <img
                    src={`${API}${req.old_photo_url}`} alt="" onClick={() => setLightboxUrl(`${API}${req.old_photo_url}`)}
                    style={{ width: 140, height: 140, borderRadius: 8, objectFit: 'cover', cursor: 'zoom-in' }}
                  />
                ) : (
                  <div style={{ width: 140, height: 140, borderRadius: 8, background: colors.surface2, display: 'flex', alignItems: 'center', justifyContent: 'center', color: colors.textMuted, fontSize: 12 }}>
                    Нет фото
                  </div>
                )}
              </div>
              <div>
                <div style={{ fontSize: 12, color: colors.textMuted, marginBottom: 6 }}>Станет</div>
                <img
                  src={`${API}${req.new_photo_url}`} alt="" onClick={() => setLightboxUrl(`${API}${req.new_photo_url}`)}
                  style={{ width: 140, height: 140, borderRadius: 8, objectFit: 'cover', border: `2px solid ${colors.accent}`, cursor: 'zoom-in' }}
                />
              </div>
            </div>

            {rejectingId === req.id ? (
              <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                <textarea
                  style={{ ...ui.input, flex: 1, minHeight: 60 }}
                  placeholder="Причина отклонения — увидит пользователь"
                  value={reason}
                  onChange={e => setReason(e.target.value)}
                />
                <button style={ui.btnDanger} onClick={() => confirmReject(req)} disabled={!reason.trim()}>Отклонить</button>
                <button style={ui.btnSecondary} onClick={cancelReject}>Отмена</button>
              </div>
            ) : (
              <div style={{ display: 'flex', gap: 8 }}>
                <button style={ui.btn} onClick={() => approve(req)}>Одобрить</button>
                <button style={ui.btnDanger} onClick={() => startReject(req)}>Отклонить</button>
              </div>
            )}
          </div>
        ))
      )}

      <PhotoLightbox url={lightboxUrl} onClose={() => setLightboxUrl(null)} />
    </Layout>
  );
}
